import React from "react";
import Modal from "react-modal";
import crssrImage from "../../../../../images/singleinvoice/cross-red.svg";

const SkippedRowsModal = ({
  isOpen,
  onClose,
  skippedRows,
  trackedEntriesCount,
  onContinue,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Skipped Rows"
      className="bulk-import-popup"
      style={{
        content: {
          height: "60%",
          width: "60%",
          position: "fixed",
          top: "50%",
          left: "50%",
          overflowY: "auto",
        },
      }}
    >
      <div className="modal">
        <div className="outter-modal-main">
          <a
            className="close-image-clr1"
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
          >
            <img src={crssrImage} alt="Close Skipped Rows" />
          </a>
        </div>
        <div className="outter-modal-main">
          <h2 className="modal-title modal-title-skipped">Skipped Rows</h2>
          <div className="skipped-rows-list">
            <table className="skipped-rows-table">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {skippedRows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <span className="row-count-sec">
                        Row<span> {row.index}</span>
                      </span>
                    </td>
                    <td>{row.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            className="submit-client cancel-sprint mt-4 skipped-continue"
            onClick={onContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SkippedRowsModal;

